/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/heading-has-content */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addItem, clearCart } from "../../redux/slices/CartSlice";
import { useWishedNft } from "../../Hooks/api/useWishedNft";
import { useCartNfts } from "../../Hooks/api/useCartNfts";
import GradientButton from "../Buttons/GradientButton/GradientButton";
import LikeButton from "../Buttons/LikeButton/LikeButton";
import CheckoutModal from "../Modals/CheckoutModal/CheckoutModal";
import SingleNftModule from "../Modals/SingleNftModule/SingleNftModule";
import StyledMdText from "../../common/components/styledMdText/StyledMdText";
import StyledH6Heading from "../../common/components/styledH6Heading/StyledH6Heading";
import { useAccount } from "wagmi";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import NftCartHub from "../Modals/NftCartHub/NftCartHub";
import { useClearAllNfts } from "../../Hooks/api/useClearAllNfts";
const NftCard = ({ nft, wishList = false }) => {
  const [showCheckoutModal, setShowCheckoutModal] = useState(false);
  const [showSingleNftModule, setShowSingleNftModule] = useState(false);
  const [showNftCartHub, setShowNftCartHub] = useState(false);
  const dispatch = useDispatch();
  const walletAddress = useSelector((state) => state.user.walletAddress);
  const { mutate } = useClearAllNfts();
  const Tier = nft?.tier.replace(/([a-zA-Z])(\d+)/, "$1 $2");
  const [imageLoader, setImageLoader] = useState(false);
  const { openConnectModal } = useConnectModal();
  const cartNFTs = useSelector((state) => state.cart.items);
  const isInCart = cartNFTs.some((item) => item.nft_id === nft.nft_id);
  const CART_EXPIRY_TIME = 600000;
  useEffect(() => {
    if (walletAddress && cartNFTs.length > 0) {
      const interval = setInterval(() => {
        const storedTime = localStorage.getItem("cartTimestamp");
        if (Date.now() > parseInt(storedTime, 10)) {
          dispatch(clearCart());
          mutate({ wallet_address: walletAddress });
          localStorage.removeItem("cartTimestamp");
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [dispatch, isInCart, walletAddress, mutate]);

  useEffect(() => {
    const img = new Image();
    img.src = nft.image;
    img.onload = () => setImageLoader(true);
  }, [nft.image]);
  const handleImageLoad = () => {
    setImageLoader(true);
  };

  const handleImageError = () => {
    setImageLoader(false);
  };

  const { address } = useAccount();
  const { mutate: handleCartNft } = useCartNfts();
  const { mutate: handleWishlistNft, isPending } = useWishedNft();

  const handleWishlistAction = (action) => {
    const payload = {
      nftId: nft.nft_id,
      wallet_address: address,
      action,
    };
    handleWishlistNft(payload);
  };

  const handleAddToCart = () => {
    dispatch(addItem(nft));
    handleCartNft({
      nftId: nft.nft_id,
      walletAddress: address,
      action: "add",
      contract_address: process.env.REACT_APP_CONTRACT_ADDRESS,
    });
    localStorage.setItem(
      "cartTimestamp",
      (Date.now() + CART_EXPIRY_TIME).toString()
    );
  };
  const singleNFTHandle = () => {
    if (!walletAddress) {
      return null;
    }
    setShowSingleNftModule(true);
  };

  const renderActionButtons = () => {
    if (!walletAddress || !address) {
      return (
        <div className="w-full">
          <GradientButton
            fontColor="w-full text-nowrap"
            onClick={openConnectModal}
          >
            Connect Wallet
          </GradientButton>
        </div>
      );
    }

    if (nft?.minted) return null;

    return isInCart ? (
      <GradientButton
        onClick={() => setShowNftCartHub(true)}
        fontColor="w-full text-nowrap"
      >
        Added To Cart
      </GradientButton>
    ) : (
      <>
        <GradientButton
          onClick={() => setShowCheckoutModal(true)}
          fontColor="w-full text-nowrap"
        >
          Buy Now
        </GradientButton>
        <GradientButton
          fontColor="w-full flex justify-center items-center sm:w-fit"
          onClick={handleAddToCart}
        >
          <img
            src="/assets/cart-black.svg"
            alt="Add to cart"
            width={22}
            loading="lazy"
          />
        </GradientButton>
      </>
    );
  };

  return (
    <>
      <div className="relative group border hover:border-bright-yellow bg-light-black rounded-[14px] overflow-hidden flex flex-col justify-between">
        <div className="relative  ">
          {imageLoader ? (
            <img
              onClick={singleNFTHandle}
              src={nft.image}
              alt="NFT's"
              className="w-full cursor-pointer"
              onLoad={handleImageLoad}
              onError={handleImageError}
              loading="lazy"
            />
          ) : (
            <div className="relative w-full h-[228px] animate-pulse  bg-gray-400"></div>
          )}
          <div className="absolute top-0 left-0 w-full flex justify-between px-4 py-2.5">
            {nft.minted &&
              (imageLoader ? (
                <StyledMdText fontColor="border rounded-full px-3 flex items-center bg-transparent backdropFilter-blur">
                  Minted
                </StyledMdText>
              ) : (
                <div className="text-md font-normal font-inter border rounded-full px-3 flex items-center bg-gray-300 w-16 h-6 animate-pulse"></div>
              ))}
            {walletAddress &&
              (wishList ? wishList : !nft?.minted && address) && (
                <div className="w-full flex justify-end">
                  {imageLoader ? (
                    <LikeButton
                      liked={nft?.wishlistData}
                      onLike={() => handleWishlistAction("add")}
                      onDislike={() => handleWishlistAction("remove")}
                      disabled={isPending}
                    />
                  ) : (
                    <div className="absolute top-0 left-0 w-full flex justify-between px-4 py-2.5">
                      <div className="w-full flex justify-end">
                        <div className="w-6 h-6 bg-gray-200 animate-pulse rounded-full"></div>
                      </div>
                    </div>
                  )}
                </div>
              )}
          </div>
        </div>
        <div className="bg-light-black px-3 py-1.5 flex flex-col gap-2 justify-between h-full ">
          <div>
            {imageLoader ? (
              <div className="flex justify-between items-center">
                <StyledMdText className="">{Tier}</StyledMdText>
                <div className="flex gap-2 items-center">
                  <img
                    src="/assets/price-icon.svg"
                    alt="Edit Profile"
                    loading="lazy"
                  />
                  <div className="text-[17px] font-medium">{nft.price}</div>
                </div>
              </div>
            ) : (
              <div className="flex justify-between">
                <p className="w-16 h-4 bg-gray-300 rounded"></p>
                <div className="flex gap-2 items-center">
                  <div className="w-5 h-5 bg-gray-300 rounded-full"></div>
                  <p className="w-10 h-4 bg-gray-300 rounded"></p>
                </div>
              </div>
            )}

            {imageLoader ? (
              <StyledH6Heading className="pt-1">{nft.name}</StyledH6Heading>
            ) : (
              <h6 className="w-2/3 h-5 pt-1 bg-gray-300 rounded mt-2"></h6>
            )}
          </div>
          {imageLoader ? (
            <div className="w-full flex md:group-hover:flex flex-col sm:flex-row justify-between gap-2 py-1">
              {renderActionButtons()}
            </div>
          ) : (
            <div className="w-full flex flex-col sm:flex-row justify-between gap-2 py-1">
              <div className="h-10 w-full sm:w-[80%] bg-gray-200 animate-pulse rounded"></div>
              <div className="h-10 w-full sm:w-[20%] bg-gray-200 animate-pulse rounded"></div>
            </div>
          )}
        </div>
        {showCheckoutModal && (
          <CheckoutModal
            key={nft.id}
            nft={nft}
            closeModal={() => setShowCheckoutModal(false)}
          />
        )}
        {showSingleNftModule && (
          <SingleNftModule
            key={nft.id}
            nft={nft}
            closeModal={() => setShowSingleNftModule(false)}
          />
        )}
        {showNftCartHub && (
          <NftCartHub closeModal={() => setShowNftCartHub(false)} />
        )}
      </div>
    </>
  );
};

export default NftCard;
